import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AssistentBanner } from "@/components/AssistentBanner";

interface CTAProps {
  title?: string;
  description?: string;
  variant?: "default" | "minimal";
  /** When true, shows an "Offerte aanvragen" button instead of "Plan een gesprek" */
  showOfferte?: boolean;
}

export function CTA({ 
  title = "Zullen we kennismaken?",
  description = "Je kunt mij bellen of plan een online meeting in. \nVrijblijvend bespreken we wat ik voor je kan betekenen.",
  variant = "default",
  showOfferte = false,
}: CTAProps) {
  const primaryLink = showOfferte ? "/offerte-aanvragen" : "/kennismaking";
  const primaryLabel = showOfferte ? "Vraag offerte aan" : "Plan een gesprek";

  if (variant === "minimal") {
    return (
      <section className="section-padding-sm border-t border-border">
        <div className="container-narrow text-center">
          <h3 className="mb-4">{title}</h3>
          <p className="text-muted-foreground mb-8 whitespace-pre-line">{description}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg">
              <Link to={primaryLink}>
                {primaryLabel}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <a href="tel:+31592887788">
                <Phone className="mr-2 h-4 w-4" />
                0592 88 77 88
              </a>
            </Button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding border-t border-border">
      <div className="container-narrow text-center">
        <h2 className="mb-6">{title}</h2>
        <p className="text-lead max-w-xl mx-auto mb-10 whitespace-pre-line">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="xl">
            <Link to={primaryLink}>
              {primaryLabel}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <Button asChild size="xl" variant="outline">
            <a href="tel:+31592887788">
              <Phone className="mr-2 h-4 w-4" />
              0592 88 77 88
            </a>
          </Button>
        </div>
        <div className="mt-8 flex flex-col items-center gap-3">
          <AssistentBanner variant="inline" />
          <p className="text-small">
            Liever mailen?{" "}
            <a href="mailto:info@onlinesalespecialist.nl" className="underline hover:text-accent transition-colors">
              info@onlinesalespecialist.nl
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
